export const GENDER_OPTIONS = [
  {
    label: "customer.additionalInfo.fields.gender.options.male",
    value: "1"
  },
  {
    label: "customer.additionalInfo.fields.gender.options.female",
    value: "2"
  },
  {
    label: "customer.additionalInfo.fields.gender.options.other",
    value: "3"
  }
];

export const MARITAL_STATUS_OPTIONS = [
  {
    label: "customer.data.fields.maritalStatus.options.single",
    value: "1"
  },
  {
    label: "customer.data.fields.maritalStatus.options.married",
    value: "2"
  }
];

export const CONFIRM_CONSENT_OPTIONS = [
  {
    label: "customer.consent.fields.consentAll.yes",
    value: "true"
  },
  {
    label: "customer.consent.fields.consentAll.no",
    value: "false"
  }
];

export const CUSTOMER_DETAILS_COLUMNS = [
  "honorificPrefix",
  "familyName",
  "givenName",
  "middleName",
  {
    value: "alternateFamilyName1",
    label: "customer.additionalInfo.fields.globalLastName.label"
  },
  {
    value: "alternateGivenName1",
    label: "customer.additionalInfo.fields.globalFirstName.label"
  },
  {
    value: "gender",
    label: "customer.additionalInfo.fields.gender.label",
    options: GENDER_OPTIONS
  },
  "birthDate",
  "email",
  "mobileTelephone",
  "telephone",
  {
    value: "postalCode",
    label: "customer.data.fields.address.postCode.label"
  },
  {
    value: "addressRegion",
    label: "customer.data.fields.address.region.label"
  },
  {
    value: "addressLocality",
    label: "customer.data.fields.address.city.label"
  },
  {
    value: "streetAddress1",
    label: "customer.data.fields.address.line1.label"
  },
  {
    value: "streetAddress2",
    label: "customer.data.fields.address.line2.label"
  },
  {
    value: "addressCountry",
    label: "customer.data.fields.address.country.label"
  },
  {
    value: "maritalStatus",
    label: "customer.data.fields.maritalStatus.label",
    options: MARITAL_STATUS_OPTIONS
  },
  "weddingDate",
  "profession",
  {
    value: "confirmConsent",
    label: "customer.consent.fields.confirmConsent.label",
    options: CONFIRM_CONSENT_OPTIONS
  }
];

export const RESULT_FIELDS = [
  ["familyName", "alternateFamilyName1"],
  ["givenName", "alternateGivenName1"],
  ["mobileTelephone", "telephone"],
  "email"
];
